import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ComplianceConfirmation } from '../ComplianceConfirmation/ComplianceConfirmation';
import { ReviewModalNotes } from '../ReviewModalNotes/ReviewModalNotes';

import { reviewModalModalDialogActionsStyles as sx } from './ReviewModalDialogActions.styles';

type Props = {
	onBack: () => void;
	onClose: () => void;
};

export const ReviewModalDialogActions = ({ onBack, onClose }: Props) => {
	const { t } = useTranslation();
	const { control } = useFormContext();

	const isThirdPartyDataConfirmed = useWatch({
		control,
		name: 'isThirdPartyDataConfirmed'
	});

	return (
		<Box sx={sx.root}>
			<ReviewModalNotes control={control} />
			<ComplianceConfirmation control={control} />

			<Box sx={sx.actions}>
				<Box flexGrow={1}>
					<Button
						variant='text'
						onClick={onBack}
						startIcon={<NavigateBeforeIcon fontSize='small' />}
					>
						{t('Back')}
					</Button>
				</Box>

				<Button variant='text' onClick={onClose}>
					{t('Cancel')}
				</Button>

				<Button
					type='submit'
					variant='contained'
					disabled={!isThirdPartyDataConfirmed}
				>
					{t('Submit')}
				</Button>
			</Box>
		</Box>
	);
};
